define(
	'constants/actiontypes',[
	],
	function(){
		var Constants = {
			// Classes
			CREATED_CLASS: 0,
			UPDATED_CLASS: 1,
			// Assignments
			CREATED_ASSIGNMENT: 10,
			UPDATED_ASSIGNMENT: 11,
			DELETED_ASSIGNMENT: 12,
			PULLING_ALL_ASSIGNMENTS: 13,
			TRUNCATE_ASSIGNMENT: 14,
			// Students
			ADD_STUDENTS: 20,
			UPDATED_STUDENT: 21,
			ENROLL_STUDENT_CLASS: 22,
			DISENROLL_STUDENT_CLASS: 23,
			// Groups
			CREATED_GROUP: 30,
			UPDATED_GROUP: 31,
			DELETED_GROUP: 32,
			TRUNCATE_GROUP: 33,
			// Buncees
			CREATED_BUNCEE: 40,
			DELETED_BUNCEE: 41,
			// Submissions
			CREATED_SUBMISSION: 50,
			UPDATED_SUBMISSION: 51,
			DELETED_SUBMISSION: 52,
			// Subission responses
			CREATED_SUBMISSION_RESPONSE: 60,
			UPDATED_SUBMISSION_RESPONSE: 61,
			DELETED_SUBMISSION_RESPONSE: 62,
			// Organizer
			CREATED_ORGANIZER: 70,
			UPDATED_ORGANIZER: 71,
			DELETED_ORGANIZER: 72,
			FETCHED_ORGANIZER: 73,
			// About settings
			SET_COMMENTABLE: 80,
			SET_COPYABLE: 81,
			SET_PRIVACY: 82,
			// Comments
			ADD_COMMENT: 90,
			REMOVE_COMMENT: 91,
			// Tags
			ADD_TAG: 92,
			REMOVE_TAG: 93,
			// Like counts
			SET_LIKE_COUNT: 100,
			TOGGLE_LIKE_STATE: 101,
			// Notifications
			CREATE_NOTIFICATION : 110,
			SORT_NOTIFICATIONS : 111,
			MARK_NOTIFICATION_READ : 112,
			// Clips
			CREATED_CLIP: 120,
			UPDATED_CLIP: 121,
			DELETED_CLIP: 122,
			// Email activities
			INIT_EMAIL_ACTIVITIES: 130,
			REFRESH_EMAIL_ACTIVITY: 131,
			// Email activity details
			INIT_EMAIL_ACTIVITY_DETAILS: 140,
			// Etc.
			CLEAR_SECTION_CACHE: 150,
			// Contacts
			CREATED_CONTACT: 160,
			UPDATED_CONTACT: 161,
			DELETED_CONTACT: 162,
			//RSVPs
			ADD_RSVP: 170,
			UPDATE_RSVP: 171,
			ADD_RSVP_SUMMARY: 172,
			REFRESH_RSVP_SUMMARY: 173,
			INIT_RSVP_COMMENT: 174,
			REMOVE_RSVP_COMMENT: 175,

			//Boards
			CREATE_BOARD: 180,
			DELETE_BOARD: 181,

			//Announcements
			CREATE_ANNOUNCEMENT: 190,

			// Badges
			ADD_BADGE: 200,

			// Shared entities
			CREATED_SHARED_ENTITY: 210,
			DELETED_SHARED_ENTITY: 211,

			// Followed Entities
			CREATE_FOLLOWED_ENTITY: 220,
			DELETE_FOLLOWED_ENTITY: 221,

			// Idea Lab
			CREATED_IDEASLAB: 222,
			FETCHED_IDEASLAB: 223,

			// Pins
			ADD_PIN: 231,

			// Streaks
			ADD_STREAKS: 240,

			// Streaks
			ADD_STREAKS: 250,

			// Sessions
			ADD_SESSIONS: 260,

			// Resource Buncees
			ADD_RESOURCE_BUNCEES: 270,

		};

		return Constants;
	}
);
